module.exports = function() {
  return new Worker(__webpack_public_path__ + "bd572d15f24caa569fe7.worker.js");
};